import React, {FC} from "react";

import {RectState} from "./CreateRectModal";
import {LineState} from "./CreateLineModal";
import {TextState} from "./CreateTextModal";
import {ArcState} from "./CreateArcModal";
import {RenderObjectTypes} from "../lib/Types";
import TextControls from "./TextControls";
import LineControls from "./LineControls";
import ArcControls from "./ArcControls";
import RectControls from "./RectControls";

interface ControlsSelectorProps {
    object: RectState | LineState | TextState | ArcState;
    onModifyObject: (object: Partial<RectState> | Partial<LineState> | Partial<TextState> | Partial<ArcState>) => void;
    onHide: () => void;
}

const ControlsSelector: FC<ControlsSelectorProps> = ({
                                                         object,
                                                         onModifyObject,
                                                         onHide
                                                     }) => {
    switch (object.type) {
        case RenderObjectTypes.TEXT:
            return <TextControls object={object} onModifyObject={onModifyObject} onHide={onHide}/>;
        case RenderObjectTypes.LINE:
            return <LineControls object={object} onModifyObject={onModifyObject} onHide={onHide}/>;
        case RenderObjectTypes.ARC:
            return <ArcControls object={object} onModifyObject={onModifyObject} onHide={onHide}/>;
        case RenderObjectTypes.RECT:
            return <RectControls object={object} onModifyObject={onModifyObject} onHide={onHide}/>;
        default:
            return null;
    }
};

export default ControlsSelector;